import React from "react";

const FailedRecordsStep = ({ uploadStatusData, uploadType }) => {
  const failedRecords = uploadStatusData?.detail || [];

  return (
    <div className="editcontianer">
      <h2>Failed Records</h2>
      <table>
        <thead>
          <tr>
            {uploadType === "eventCreate" && (
              <>
                <th>Event Name</th>
                <th>Date</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th>Event Level</th>
                <th>Event Round</th>
                <th>Failure Reason</th>
              </>
            )}
            {uploadType === "eventReschedule" && (
              <>
                <th>Event Name</th>
                <th>Start Date Time</th>
                <th>End Date Time</th>
                <th>Level</th>
                <th>Round</th>
                <th>Failure Reason</th>
              </>
            )}
            {uploadType === "eventDelete" && (
              <>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Level</th>
                <th>Round</th>
                <th>Failure Reason</th>
              </>
            )}
            {(uploadType === "studentRegister" || !uploadType) && (
              <>
                <th>ISD Code</th>
                <th>Phone</th>
                <th>Failure Reason</th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {failedRecords.map((record, index) => (
            <tr key={index}>
              {uploadType === "eventCreate" && (
                <>
                  <td>{record.event_name}</td>
                  <td>{record.date}</td>
                  <td>{record.start_time}</td>
                  <td>{record.end_time}</td>
                  <td>{record.event_level}</td>
                  <td>{record.event_round}</td>
                  <td>{record.failure_reason}</td>
                </>
              )}
              {uploadType === "eventReschedule" && (
                <>
                  <td>{record.event_name}</td>
                  <td>{record.start_date_time}</td>
                  <td>{record.end_date_time}</td>
                  <td>{record.level}</td>
                  <td>{record.round}</td>
                  <td>{record.failure_reason}</td>
                </>
              )}
              {uploadType === "eventDelete" && (
                <>
                  <td>{record.start_date}</td>
                  <td>{record.end_date}</td>
                  <td>{record.level}</td>
                  <td>{record.round}</td>
                  <td>{record.failure_reason}</td>
                </>
              )}
              {(uploadType === "studentRegister" || !uploadType) && (
                <>
                  <td>{record.isd_code}</td>
                  <td>{record.phone}</td>
                  <td>{record.failure_reason}</td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FailedRecordsStep;
